import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';
import PageWrapper from '../../components/PageWrapper';
import Filters from '../../components/Filters';
import HomesResults from './HomesResults';

const styles = css``;

const sortOptions = [
  { title: 'City', field: 'address.addressLocality' },
  { title: 'Price Low To High', field: 'price' },
  { title: 'Price High To Low', field: 'price', dir: 'desc' },
  { title: 'Address', field: 'address.streetAddress' },
  { title: 'State', field: 'address.addressRegion' },
];

class ModelHomes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      showMap: false,
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { page } = this.props;
    const { sort, showMap } = this.state;

    return (
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          page={page}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuFind />
        <Filters
          type="homes"
          filterOptions={[
            {
              type: 'SingleSelect',
              filter: 'Area',
              title: 'City',
              placeholder: 'All Cities',
              routeParam: 'communityMarketArea',
            },
            {
              type: 'MultiSelect',
              filter: 'Beds',
              title: 'Beds',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Baths',
              title: 'Baths',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Community',
              title: 'Community',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Price',
              title: 'Price Range',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'SchoolDistrict',
              title: 'School Districts',
              placeholder: 'All Districts',
            },
          ]}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          showMap={showMap}
          onToggleMap={this.setShowMap}
        />
        <HomesResults sort={sort} showMap={showMap} />
      </PageWrapper>
    );
  }
}

ModelHomes.propTypes = {
  page: PropTypes.object.isRequired,
};

ModelHomes.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    page: 'model_homes',
  },
  {
    required: {
      page: true,
    },
  },
)(ModelHomes);



// WEBPACK FOOTER //
// ./src/pages/ModelHomes/index.js